<template>
  <div class="email-template">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('notification.email_template') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createItem">
                  <i class="fa fa-plus"></i>&nbsp; {{$t('menu-attribute.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <b-col xl="3">
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('common.active')">
                      <b-form-select v-model="filter.active" v-bind:value="filter.active"
                      :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('common.active')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col xl="3">
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('common.email_types')">
                      <b-form-select v-model="filter.email_type_id" v-bind:value="filter.email_type_id"
                                     :options="email_types[$session.get('lang')]" v-bind:placeholder="$t('common.email_types')">
<!--                        <b-form-select-option :value=null selected>{{$t('common.all')}}</b-form-select-option>-->
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col xl="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options"
                    position="prepend" v-bind:all="false" v-model="filter.field" prefix="menu-attribute">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('common.active')}}</th>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <i class="fa fa-sort-amount-asc text-muted"
                      v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted"
                      v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('menu-attribute.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('menu-attribute.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 2">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" @change="updateStatusItem(item)" />
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                      <span v-if="field.render != null"
                      v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="192">
                      <span style="display:inline-block; padding: 4px;">
                        <b-button size="sm" variant="primary" v-on:click="editItem(item.id)">
                          <i class="fa fa-edit"></i> {{$t('common.edit')}}
                        </b-button>
                      </span>
                      <span style="display:inline-block; padding: 4px;">
                        <b-button size="sm" variant="danger" v-on:click="diffItem(item.id)" style="border-radius: 0.2em;">
                          <i class="fa fa-gavel"></i> {{$t('email_template.changes_history')}}
                        </b-button>
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                  v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style>
  .switch-success > .switch-input:checked ~ .switch-label,
  .btn-success,
  .btn-primary
  {
    background: #0086FF !important;
    border-color: #0086FF !important;
    border-radius: 3px;
  }
</style>
<style scoped>
  .table thead th:nth-child(1){
    width: 100px;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import axios from 'axios'
import cSwitch from '../../../components/Switch'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'MenuAttributeList',
  components: {
    SelectDropdown,
    cSwitch,
    DataTable
  },
  data: function () {
    return {
      authUser: this.$auth.user().user_info.user,
      languages: {},
      type: 'like',
      statuses: [],
      email_types: [],
      filter: {
        options: [],
        active: 1,
        email_type_id: null,
        name: '',
        field: null,
        key: null,
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')] ||  data['en']
            }
          },
          {
            name: 'subject',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')] || data['en']
            }
          },
          {
            name: 'note',
            filter: false,
            sort: false,
            render: (data, row) => {
              return data
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {}
    }
  },
  methods: {
    publishMenuAttribute() {
      vm.axios.menu.publishMenuAttribute(function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.refreshData()
      })
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in vm.dataTable.fields) {
        if (vm.dataTable.fields[i].name == field
        && (vm.dataTable.fields[i].sort == null || vm.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (vm.dataTable.sort.field != field) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (vm.dataTable.sort.type == 'asc') {
          vm.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      vm.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }

      //get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_field: this.dataTable.sort.field,
        sort_type: this.dataTable.sort.type
      }
      let active = '';
      if (String(this.filter.active) != '') {
        _data['active'] = this.filter.active
      }
      let email_type_id = '';
      if (this.filter.email_type_id) {
        _data['email_type_id'] = this.filter.email_type_id
      }
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      //process to send via get method
      let params = '';
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      //remove tail
      params = params.slice(0, -1)
      vm.axios.notification.getEmailTemplateList(params,
        function(response){
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data._metadata.total
        });
    },
    /**
     * move to detail page by uuid
     * @param id
     */
    editItem (id) {
      this.$router.push({name: 'email_template_edit', params: { id: id }})
    },
    /**
     * move to diff page by uuid
     * @param id
     */
    diffItem (id) {
      this.$router.push({name: 'email_template_diff', params: { id: id }})
    },
    /**
     * update active by id
     * @param id and active
     */
    updateStatusItem (item) {
      item.content = JSON.parse(item.content);
      for (const lang in item.content) {
        item.content[lang] = btoa(unescape(encodeURIComponent(item.content[lang])))
      }
      vm.axios.notification.updateEmailTemplate(item, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.refreshData()
        // eslint-disable-next-line handle-callback-err
      }, function (error) {
        vm.refreshData()
      }, { email: vm.authUser.email })
    },
    createItem: function(){
      this.$router.push({name: 'email_template_create', params: { id: 'create' }})
    },
    /**template
     * get list categories for select box
     */
    getEmailTypeList () {
      const vm = this
      vm.axios.notification.getEmailTypeList({},
        function(response){
          const langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.email_types[langs[l]] = []
            for (const item of response.data.data.items) {
              vm.email_types[langs[l]].push({text: item.code, value: item.id})
            }
            vm.email_types[langs[l]].unshift({text: vm.$t('common.all', langs[l]), value: null})
          }
        })
    },
    /**template
     * get list email_types for select box
     */
    getStatusList () {
      let langs = vm.$store.getters.languages
      for (let l in langs) {
        vm.statuses[langs[l]] = [
          {text: vm.$t('common.all', langs[l]), value: ""},
          {text: vm.$t('common.active', langs[l]), value: '1'},
          {text: vm.$t('common.inactive', langs[l]), value: '0'}
        ]
      }
    },
    getSortFilter () {
      for (let i in vm.dataTable.fields) {
        vm.getFilter(i)
        vm.getSort(i)
      }
    },
    getFilter (i) {
      if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
    },
    getSort (i) {
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true
        && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: vm.dataTable.fields[i].name,
          type: 'asc'
        }
      }
    },
    applyFilter () {
      let filter = vm.$session.get('filter', null)
      if (filter != null && vm.$route.query && vm.$route.query.rollback) {
        for (let i in filter.filter) {
          vm.filter[i] = filter.filter[i]
        }
        for (let i in filter.dataTable) {
          vm.dataTable[i] = filter.dataTable[i]
        }
      }
    }
  },
  created: function () {
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()
    vm.getSortFilter()
    vm.$Progress.start()
    vm.getStatusList()
    vm.getEmailTypeList()
    vm.applyFilter()
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
    'filter.active': function (val) {
      vm.refreshData()
    },
    'filter.email_type_id': function (val) {
      vm.refreshData()
    }
  },
  computed : {
    ranges : function () {
      return vm.format_date_ranges()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/email-template/List.vue